export enum JunctionOperator {
    And = "And",
    Or = "Or"
}